<template>
    <ResponsiveDialog
        v-model="internalValue"
        :max-width="640"
        :header-title="$t('dashboard.typeChart.title')"
    >
        <v-card-text class="type-chart__scroll">
            <div class="type-chart__grid">
                <TypePill
                    v-for="typeId in headers"
                    :key="typeId"
                    :type="{id: typeId}"
                    class="ma-1 type-chart__type-btn"
                    :class="{'type-chart__type-btn--selected': typeId === selectedType}"
                    @click="selectType(typeId)"
                >{{ typeName(typeId) }}</TypePill>
            </div>

            <template v-if="selectedType">
                <v-divider class="my-3"/>

                <div v-if="attackStrong(selectedType).length" class="type-chart__group">
                    <div class="type-chart__group-title">{{ $t('dashboard.typeChart.attackStrong') }}</div>
                    <div class="type-chart__chips">
                        <TypePill
                            v-for="t in attackStrong(selectedType)"
                            :key="t"
                            :type="{id: t}"
                            size="small"
                            class="ma-1"
                        >{{ typeName(t) }}</TypePill>
                    </div>
                </div>
                <div v-if="attackWeak(selectedType).length" class="type-chart__group">
                    <div class="type-chart__group-title">{{ $t('dashboard.typeChart.attackWeak') }}</div>
                    <div class="type-chart__chips">
                        <TypePill
                            v-for="t in attackWeak(selectedType)"
                            :key="t"
                            :type="{id: t}"
                            size="small"
                            class="ma-1"
                        >{{ typeName(t) }}</TypePill>
                    </div>
                </div>
                <div v-if="defenseWeak(selectedType).length" class="type-chart__group">
                    <div class="type-chart__group-title">{{ $t('dashboard.typeChart.defenseWeak') }}</div>
                    <div class="type-chart__chips">
                        <TypePill
                            v-for="t in defenseWeak(selectedType)"
                            :key="t"
                            :type="{id: t}"
                            size="small"
                            class="ma-1"
                        >{{ typeName(t) }}</TypePill>
                    </div>
                </div>
                <div v-if="defenseResist(selectedType).length" class="type-chart__group">
                    <div class="type-chart__group-title">{{ $t('dashboard.typeChart.defenseResist') }}</div>
                    <div class="type-chart__chips">
                        <TypePill
                            v-for="t in defenseResist(selectedType)"
                            :key="t"
                            :type="{id: t}"
                            size="small"
                            class="ma-1"
                        >{{ typeName(t) }}</TypePill>
                    </div>
                </div>
            </template>

            <div class="type-chart__scroll-spacer"/>
        </v-card-text>
    </ResponsiveDialog>
</template>

<script>
    import {mapActions} from 'vuex';
    import ResponsiveDialog from '@/components/utils/ResponsiveDialog';
    import TypePill from '@/components/utils/TypePill';

    export default {
        name: 'TypeChartDialog',
        components: {ResponsiveDialog, TypePill},
        props: {
            value: {type: Boolean, default: false},
        },
        data() {
            return {
                headers: [],
                table: [],
                loaded: false,
                selectedType: null,
            }
        },
        computed: {
            internalValue: {
                get() {
                    return this.value;
                },
                set(v) {
                    this.$emit('input', v);
                },
            },
        },
        watch: {
            value(isOpen) {
                if (isOpen && !this.loaded) {
                    this.loadTable();
                }
            },
        },
        methods: {
            ...mapActions({
                loadTypeTable: 'dashboard/loadTypeTable',
            }),
            loadTable() {
                this.loadTypeTable().then((data) => {
                    this.headers = data.headers;
                    this.table = data.table;
                    this.loaded = true;
                });
            },
            typeName(typeId) {
                return this.$t('common.typeNames.' + (typeId.charAt(0) + typeId.slice(1).toLowerCase()));
            },
            selectType(typeId) {
                this.selectedType = this.selectedType === typeId ? null : typeId;
            },
            attackStrong(typeId) {
                return this.relatedTypes(typeId, 'attack', 1.5);
            },
            attackWeak(typeId) {
                return this.relatedTypes(typeId, 'attack', 0.5);
            },
            defenseWeak(typeId) {
                return this.relatedTypes(typeId, 'defense', 1.5);
            },
            defenseResist(typeId) {
                return this.relatedTypes(typeId, 'defense', 0.5);
            },
            relatedTypes(typeId, direction, multiplier) {
                const i = this.headers.indexOf(typeId);
                if (i === -1) {
                    return [];
                }
                return this.headers.filter((_, j) => {
                    const value = direction === 'attack' ? this.table[i][j] : this.table[j][i];
                    return value === multiplier;
                });
            },
        },
    }
</script>

<style scoped>
    .type-chart__scroll {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
    }

    .type-chart__grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .type-chart__type-btn {
        cursor: pointer;
    }

    /* funguje citelne bez ohledu na barvu podkladove pilulky (TYPE_COLORS maji siroke rozpeti svetlych/tmavych odstinu) */
    .type-chart__type-btn--selected {
        box-shadow: 0 0 0 3px #FFD700, 0 2px 6px rgba(0, 0, 0, 0.4);
    }

    .type-chart__group {
        margin-bottom: 10px;
    }

    .type-chart__group-title {
        font-weight: 700;
        margin-bottom: 4px;
    }

    .type-chart__chips {
        display: flex;
        flex-wrap: wrap;
    }

    /* stejny princip jako .skill-popup__scroll-spacer v SkillPopup.vue - misto pro plovouci zaviraci krizek (ResponsiveDialog, mobil) */
    .type-chart__scroll-spacer {
        height: var(--responsive-dialog-close-clearance);
    }
</style>
